
(function() {
    // Function to inject styles into shadow DOM
    const injectShadowStyles = (shadowRoot) => {
      if (!shadowRoot) return;
      
      // Check if styles already injected
      if (shadowRoot.querySelector('#custom-form-styles')) return;
      
      const style = document.createElement('style');
      style.id = 'custom-form-styles';
      style.textContent = `
        /* Form container width */
        ._formContainer_1q1d2_30,
        [class*="formContainer"],
        [class*="form-container"] {
          width: 100% !important;
          max-width: 100% !important;
        }
        
        ._inline_1q1d2_47 {
          overflow: visible !important;
          width: 100% !important;
        }
        
        /* Form fieldset styling */
        .form._formFieldset_cit2d_82,
        ._formFieldset_cit2d_82,
        [class*="_formFieldset"] {
          padding: 2px !important;
        }
        
        /* Form field container - reverse to put label below input visually */
        /* Exclude phone_number field container */
        [class*="_formFieldContainer"]:not(:has(#label-phone_number)),
        [class*="formFieldContainer"]:not(:has(#label-phone_number)),
        [class*="form-field-container"]:not(:has(#label-phone_number)) {
          display: flex !important;
          flex-direction: column-reverse !important;
        }
        
        /* Label positioning for reversed containers */
        [class*="_formFieldContainer"]:not(:has(#label-phone_number)) label {
          top: 0 !important;
          left: 0 !important;
          margin-bottom: 8px !important;
          margin-top: 0 !important;
        }
        
        /* Hide textarea pseudo-elements */
        [class*="_formFieldContainer"]:has(textarea)::before {
          display: none !important;    
        }
        
        /* Radio button layout */
        [class*="_radioFieldSet"] [class*="_horizontalLayout"] label {
          display: grid !important;    
        }
        
        /* Keep phone_number field normal (not reversed) */
        [class*="_formFieldContainer"]:has(#label-phone_number) {
          display: flex !important;
          flex-direction: column !important;
        }
        
        /* Don't style phone_number input */
        #label-phone_number,
        input[id*="phone_number"],
        [class*="_formFieldContainer"]:has(#label-phone_number) input {
          /* Keep default styles */
        }
        
        /* Label styling - position relative and bold (except phone_number) */
        label:not(#label-phone_number,[class*="_radioField"]){
          position: relative !important;
          font-weight: bold !important;
          font-weight: 700 !important;
          color: #333 !important;
          display: block !important;
        }
        [class*="_formFieldContainer"]:focus-within [class*="_formInputFieldLabel"]:not(#label-phone_number){
          transform: none !important;
        }
        input:not(#phone_number){
          padding-top: 15px  !important;
          padding-bottom: 15px !important;
        }
        
        /* Margin only for reversed containers */
        [class*="_formFieldContainer"]:not(:has(#label-phone_number)) label {
          margin-bottom: 8px !important;
          margin-top: 0 !important;
        }
        
        [class*="_radioFieldSet"] [class*="_horizontalLayout"] label {
          display: grid !important;
        }
        
        /* Required asterisk (except phone_number) */
        label[data-required="true"]:not(#label-phone_number)::after,
        label.required:not(#label-phone_number)::after,
        [class*="label"][data-required="true"]:not(#label-phone_number)::after,
        [class*="Label"][data-required="true"]:not(#label-phone_number)::after {
          content: " *" !important;
          color: #d32f2f !important;
          font-weight: bold !important;
        }
        
        .required:not(#label-phone_number),
        [class*="required"]:not(#label-phone_number),
        [class*="Required"]:not(#label-phone_number) {
          color: #d32f2f !important;
          font-weight: bold !important;
        }
        
        /* Submit button styling */
        button[type="submit"],
        input[type="submit"],
        [class*="submit"],
        [class*="Submit"] {
            width: max-content !important;
            font-size: 16px !important;
            line-height: 25px !important;
            font-weight: 700 !important;
            color: #ffffff !important;
          background-color: #8B3A3A !important;
          background: #8B3A3A !important;
          border-color: #8B3A3A !important;
        }
        
        button[type="submit"]:hover,
        input[type="submit"]:hover,
        [class*="submit"]:hover,
        [class*="Submit"]:hover {
          background-color: #333 !important;
          background: #333 !important;
          border-color: #333 !important;
        }
        [class*="_radioFieldSet"] [class*="_horizontalLayout"] label[class*="_radioField"] {
          display: grid !important;
        }
      `;
      shadowRoot.insertBefore(style, shadowRoot.firstChild);
      
      // Direct element styling
      // Style form field containers (exclude phone_number container)
      const containers = shadowRoot.querySelectorAll('[class*="_formFieldContainer"], [class*="formFieldContainer"], [class*="form-field-container"]');
      containers.forEach(el => {
        // Check if this container has the phone_number label
        const hasPhoneLabel = el.querySelector('#label-phone_number');
        if (!hasPhoneLabel) {
          el.style.display = 'flex';
          el.style.flexDirection = 'column-reverse';
        } else {
          // Keep phone_number field normal
          el.style.display = 'flex';
          el.style.flexDirection = 'column';
        }
      });
      
      // Style labels (except phone_number)
      const labels = shadowRoot.querySelectorAll('label, [class*="label"], [class*="Label"]');
      labels.forEach(label => {
        // Skip phone_number label
        if (label.id === 'label-phone_number') return;
        
        label.style.position = 'relative';
        label.style.fontWeight = 'bold';
        label.style.color = '#333';
        
        // Only apply margin changes if parent is reversed
        const parent = label.closest('[class*="_formFieldContainer"]');
        if (parent && !parent.querySelector('#label-phone_number')) {
          label.style.marginTop = '8px';
          label.style.marginBottom = '0';
        }
        
        label.style.display = 'block';
        
        // Check if label is for required field (skip phone_number)
        if (label.id !== 'label-phone_number') {
          const isRequired = label.hasAttribute('data-required') || 
                            label.classList.contains('required') ||
                            label.textContent.includes('*');
          
          if (isRequired && !label.textContent.trim().endsWith('*')) {
            // Add asterisk if not present
            const asterisk = document.createElement('span');
            asterisk.textContent = ' *';
            asterisk.style.color = '#d32f2f';
            asterisk.style.fontWeight = 'bold';
            label.appendChild(asterisk);
          }
        }
      });
      
      
      // Style submit buttons
      const submitButtons = shadowRoot.querySelectorAll('button[type="submit"], input[type="submit"], [class*="submit"], [class*="Submit"]');
      submitButtons.forEach(btn => {
        btn.style.backgroundColor = '#8B3A3A';
        btn.style.background = '#8B3A3A';
        btn.style.borderColor = '#8B3A3A';
      });
      
      // Style required indicators (skip phone_number)
      const requiredIndicators = shadowRoot.querySelectorAll('.required, [class*="required"], [class*="Required"]');
      requiredIndicators.forEach(indicator => {
        // Skip if it's the phone_number label or inside phone_number container
        if (indicator.id === 'label-phone_number') return;
        const phoneContainer = indicator.closest('[class*="_formFieldContainer"]');
        if (phoneContainer && phoneContainer.querySelector('#label-phone_number')) return;
        
        indicator.style.color = '#d32f2f';
        indicator.style.fontWeight = 'bold';
      });
    };
    
    // Function to find and style all shadow roots
    const processShadowRoots = (root = document.body) => {
      const allElements = root.querySelectorAll('*');
      
      allElements.forEach(element => {
        if (element.shadowRoot) {
          injectShadowStyles(element.shadowRoot);
          processShadowRoots(element.shadowRoot);
        }
      });
    };
    
    // Intercept attachShadow to inject styles immediately
    const originalAttachShadow = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function(...args) {
      const shadowRoot = originalAttachShadow.apply(this, args);
      setTimeout(() => injectShadowStyles(shadowRoot), 0);
      setTimeout(() => injectShadowStyles(shadowRoot), 100);
      setTimeout(() => injectShadowStyles(shadowRoot), 500);
      return shadowRoot;
    };
    
    // Run on load
    const init = () => {
      processShadowRoots();
    };
    
    // Run multiple times to catch dynamic content
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    
    setTimeout(init, 100);
    setTimeout(init, 500);
    setTimeout(init, 1000);
    setTimeout(init, 2000);
    
    // Watch for DOM changes
    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false;
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            shouldProcess = true;
          }
        });
      });
      if (shouldProcess) {
        setTimeout(processShadowRoots, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();